/**
 * FI Notifications API Service
 *
 * Domain service for FI Notifications operations
 * Uses httpClient for infrastructure concerns (auth, token rotation, error handling)
 */

import { httpClient } from './http-client.service';
import type {
  FINotificationsListRequest,
  FINotificationsListResponse,
  FINotificationsDownloadRequest,
} from '../types/fi-notifications';

/**
 * Get paginated list of FI notifications
 */
export const getFINotificationsList = async (
  request: FINotificationsListRequest
): Promise<FINotificationsListResponse> => {
  const response = await httpClient.post<FINotificationsListResponse>(
    'finotificationlist',
    request
  );
  return response.data;
};

/**
 * Get FI notifications data for CSV download
 */
export const downloadFINotificationsData = async (
  request: FINotificationsDownloadRequest
): Promise<FINotificationsListResponse> => {
  const response = await httpClient.post<FINotificationsListResponse>(
    'finotificationlist',
    request
  );
  return response.data;
};

// Export as default object for easier mocking in tests
export const fiNotificationsAPI = {
  getFINotificationsList,
  downloadFINotificationsData,
};

export default fiNotificationsAPI;
